import(/* webpackMode: "eager" */ "/app/src/app/(site)/bang-gia/page.tsx");
